var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPsCheck({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16,
    height: 16,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-200 -68)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "url(#b)",
    cx: 180,
    cy: 104,
    r: 40
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#849D67",
    cx: 208,
    cy: 76,
    r: 12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.235 72.235a.375.375 0 0 1 .541.519l-.01.011-7 7a.375.375 0 0 1-.52.011l-.011-.01-3.5-3.5a.375.375 0 0 1 .519-.542l.011.011 3.235 3.235 6.735-6.735Z",
    fill: "#FFF"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPsCheck);
export default __webpack_public_path__ + "static/media/ps-check.38af3e0d.svg";
export { ForwardRef as ReactComponent };